module.exports = __webpack_public_path__ + "assets/images/KYD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD10.png
// module id = 1412
// module chunks = 1